import { FieldInputStrategyRegistry } from '@/Core/Contracts/UI/IFieldInputStrategy'
import {
    CheckboxFieldStrategy,
    ColorFieldStrategy,
    DateFieldStrategy,
    DateRangeFieldStrategy,
    DateTimeFieldStrategy,
    DateTimeRangeFieldStrategy,
    FileFieldStrategy,
    NumberFieldStrategy,
    PasswordFieldStrategy,
    RadioFieldStrategy,
    RadioGroupFieldStrategy,
    SelectFieldStrategy,
    StringFieldStrategy,
    SwitchFieldStrategy,
    TagsFieldStrategy,
    TextareaFieldStrategy,
} from './Strategies'

/**
 * Реєструє всі стандартні стратегії обробки полів
 * Викликається при ініціалізації додатку
 */
export function registerFieldStrategies(): void {
    // Реєструємо checkbox та switch
    FieldInputStrategyRegistry.register(new CheckboxFieldStrategy())
    FieldInputStrategyRegistry.register(new SwitchFieldStrategy())

    // Реєструємо дати
    FieldInputStrategyRegistry.register(new DateFieldStrategy())
    FieldInputStrategyRegistry.register(new DateTimeFieldStrategy())
    FieldInputStrategyRegistry.register(new DateRangeFieldStrategy())
    FieldInputStrategyRegistry.register(new DateTimeRangeFieldStrategy())

    // Реєструємо color picker
    FieldInputStrategyRegistry.register(new ColorFieldStrategy())

    // Реєструємо select (з підтримкою API ресурсів)
    FieldInputStrategyRegistry.register(new SelectFieldStrategy())

    // Реєструємо file (з підтримкою mode="multiple")
    FieldInputStrategyRegistry.register(new FileFieldStrategy())

    // Реєструємо текстові поля
    FieldInputStrategyRegistry.register(new StringFieldStrategy())
    FieldInputStrategyRegistry.register(new NumberFieldStrategy())
    FieldInputStrategyRegistry.register(new TextareaFieldStrategy())
    FieldInputStrategyRegistry.register(new PasswordFieldStrategy())

    // Реєструємо radio та tags
    FieldInputStrategyRegistry.register(new RadioGroupFieldStrategy())
    FieldInputStrategyRegistry.register(new RadioFieldStrategy())
    FieldInputStrategyRegistry.register(new TagsFieldStrategy())
}
